import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { useQuery } from 'libs/query'
import { useParams } from 'libs/router'
import { useContext } from 'react'
import { useAxiosPrivate } from 'shared/hooks'
import { HistoryRes } from 'shared/types/general.types'
import { AuthContext } from 'store'

export const useFetchProductHistory = () => {
	const params = useParams()
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)

	const { data: productHistory, isPending: isProductHistoryLoading } = useQuery<HistoryRes>({
		queryKey: queryKeys.products.history(params.id as string),
		queryFn: () => axiosPrivate.get(apiRoutes.productHistory(params.id as string)),
		enabled: !!auth.accessToken
	})

	return {
		productHistory,
		isProductHistoryLoading
	}
}
